(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TaxOfficeDeleteController',TaxOfficeDeleteController);

    TaxOfficeDeleteController.$inject = ['$uibModalInstance', 'entity', 'TaxOffice'];

    function TaxOfficeDeleteController($uibModalInstance, entity, TaxOffice) {
        var vm = this;
        vm.taxOffice = entity;
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
        vm.confirmDelete = function (id) {
            TaxOffice.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };
    }
})();
